const { same } = require('../utils');

exports.computeHasBandedRowsFromTables = tables => same(tables, 'hasBandedRows', false);
